// extracted by mini-css-extract-plugin
module.exports = {"popup":"style-module--popup--rx-np","popupClose":"style-module--popupClose--3qMOV"};